import {
  Grid,
  IconButton,
  TextField,
  LinearProgress,
  Card,
  CardContent,
  Tooltip,
  Typography,
  Stack,
  TablePagination,
  useMediaQuery,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@emotion/react";
import { DataGrid } from "@mui/x-data-grid";
import { BiTrash, BiEdit } from "react-icons/bi";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ProductSupplier,
  setSearchBody,
} from "../../../../../app/slices/productsSupplierSlice";
import ConfirmationDialog from "../../../../../helpers/ConfirmationDialog";
import { MdOutlineClear } from "react-icons/md";
import dayjs from "dayjs";
import { useNavigate } from "react-router";
import PaidIcon from "@mui/icons-material/Paid";
import Permission from "../../../../../components/userPermission/userPermission";

const ProductSupplierTable = () => {
  const dispatch = useDispatch();

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const _ProductSupplier = useSelector(
    (state) => state.productSupplier.productsSupplier
  );
  const loading = useSelector((state) => state.productSupplier.loading);
  const _SearchBody = useSelector((state) => state.productSupplier.searchBody);

  const [search, setSearch] = useState({
    search: "",
  });
  const [page, setPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);
  const [openConfirm, setConfirmOpen] = useState(false);
  const [dialogData, setDialogData] = useState("");
  const [openActive, setOpenActive] = useState(false);
  const [dialogActiveData, setDialogActiveData] = useState({});

  const handleDeleteClick = (params) => {
    setConfirmOpen(true);
    setDialogData(params);
  };

  const handleConfirmDelete = () => {
    dispatch(ProductSupplier.deleteById(dialogData.id, _SearchBody));
    setConfirmOpen(false);
  };

  const handleCancelDelete = () => {
    setConfirmOpen(false);
  };

  const handleActiveClick = (params) => {
    setOpenActive(true);
    setDialogActiveData(params);
  };

  const handleConfirmActive = () => {
    dispatch(
      ProductSupplier.activeProduct(
        dialogActiveData.id,
        {
          is_active: !dialogActiveData.is_active,
        },
        _SearchBody
      )
    );
    setOpenActive(false);
  };

  const handleCancelActive = () => {
    setOpenActive(false);
  };

  const navigate = useNavigate();

  const goTo = (path) => {
    navigate(path);
  };

  const columns = [
    {
      field: "name",
      headerName: "الاسم",
      flex: 1,
      renderCell: (params) => {
        return (
          <Tooltip title={params.row?.name}>
            <Box>{params.row?.name}</Box>
          </Tooltip>
        );
      },
    },
    {
      field: "balance",
      headerName: "الرصيد (IQD)",
      flex: 1,
      renderCell: (params) => {
        return <>{parseInt(params.row?.balance)?.toLocaleString()}</>;
      },
    },
    {
      field: "total_sold_devices",
      headerName: "عدد الاجهزة المباعة",
      flex: 1,
      renderCell: (params) => {
        return <>{params.row?.total_sold_devices?.toLocaleString()}</>;
      },
    },
    {
      field: "created_at",
      headerName: "التاريخ",
      flex: 1,
      renderCell: (params) => {
        return <>{dayjs(params.row.created_at).format("YYYY-MM-DD")}</>;
      },
    },
    {
      field: "operations",
      headerName: "العمليات",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <Tooltip title="كشف الحساب">
              <span>
                <IconButton
                  onClick={() =>
                    goTo(
                      "/app/platform/product_supplier/transactions/" +
                        params.row.id
                    )
                  }
                >
                  <PaidIcon color="success" />
                </IconButton>
              </span>
            </Tooltip>
            <Permission permission="supplier_product_edit">
              <Tooltip title="تعديل">
                <IconButton
                  onClick={() =>
                    dispatch(ProductSupplier.getById(params.row.id))
                  }
                >
                  <BiEdit />
                </IconButton>
              </Tooltip>
            </Permission>
            <Permission permission="supplier_product_delete">
              <Tooltip title="حذف">
                <IconButton onClick={() => handleDeleteClick(params.row)}>
                  <BiTrash />
                </IconButton>
              </Tooltip>
            </Permission>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(ProductSupplier.getAll(_SearchBody));
    }, 500);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_SearchBody]);

  useEffect(() => {
    dispatch(
      setSearchBody({
        search: search.search,
        skip: currentPage * page,
        take: page,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, page, search]);

  return (
    <Card>
      <CardContent>
        <Box>
          {/* {_InitialSupplierProductBalance && <InitialSupplierProductBalanceForm />} */}
          <ConfirmationDialog
            open={openConfirm}
            title="تاكيد"
            message="هل انت متاكد من حذف"
            name={dialogData.name}
            confirmText="حذف"
            cancelText="الغاء"
            onConfirm={() => handleConfirmDelete()}
            onCancel={handleCancelDelete}
          />
          <ConfirmationDialog
            open={openActive}
            title="تاكيد"
            message={`هل انت متاكد من ${
              dialogActiveData.is_active ? "الغاء تفعيل المنتج" : "تفعيل المنتج"
            }`}
            name={dialogActiveData.user_name}
            confirmText="تاكيد"
            cancelText="الغاء"
            onConfirm={() => handleConfirmActive()}
            onCancel={handleCancelActive}
          />
        </Box>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              onChange={(e) => {
                setSearch({
                  ...search,
                  search: e.target.value,
                });
              }}
              value={search.search}
              label="بحث عن الاسم "
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Tooltip title="الغاء الفلتر">
              <IconButton
                onClick={() => {
                  setSearch({
                    search: "",
                  });
                  setPage(15);
                  setCurrentPage(0);
                }}
              >
                <MdOutlineClear />
              </IconButton>
            </Tooltip>
          </Grid>
          {smallScreen ? (
            _ProductSupplier?.data?.length > 0 ? (
              <Grid item xs={12}>
                {loading ? <LinearProgress /> : null}
                <Stack spacing={1} sx={{ mt: 1 }}>
                  {_ProductSupplier.data.map((supplier, index) => (
                    <Card key={index} sx={{ borderRadius: 2 }}>
                      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                        <Stack spacing={1.5}>
                          <Stack
                            direction="row"
                            spacing={1}
                            justifyContent="space-between"
                            alignItems="flex-start"
                            sx={{
                              pb: 1,
                              borderBottom: "1px solid",
                              borderColor: "divider",
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="primary"
                              sx={{ fontWeight: 600 }}
                            >
                              {supplier?.name}
                            </Typography>
                            <Typography variant="caption" noWrap>
                              {dayjs(supplier.created_at).format("YYYY-MM-DD")}
                            </Typography>
                          </Stack>
                          <Typography variant="subtitle1">
                            الرصيد (IQD):{" "}
                            <strong>
                              {parseInt(supplier?.balance)?.toLocaleString()}
                            </strong>
                          </Typography>
                          <Typography variant="subtitle1">
                            عدد الاجهزة المباعة:{" "}
                            <strong>
                              {supplier?.total_sold_devices?.toLocaleString()}
                            </strong>
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={1}
                            justifyContent="center"
                            sx={{
                              pt: 1,
                              borderTop: "1px solid",
                              borderColor: "divider",
                            }}
                          >
                            <Tooltip title="كشف الحساب">
                              <IconButton
                                onClick={() =>
                                  goTo(
                                    "/app/platform/product_supplier/transactions/" +
                                      supplier.id
                                  )
                                }
                              >
                                <PaidIcon color="success" />
                              </IconButton>
                            </Tooltip>
                            <Permission permission="supplier_product_edit">
                              <Tooltip title="تعديل">
                                <IconButton
                                  onClick={() =>
                                    dispatch(ProductSupplier.getById(supplier.id))
                                  }
                                >
                                  <BiEdit />
                                </IconButton>
                              </Tooltip>
                            </Permission>
                            <Permission permission="supplier_product_delete">
                              <Tooltip title="حذف">
                                <IconButton
                                  onClick={() => handleDeleteClick(supplier)}
                                >
                                  <BiTrash />
                                </IconButton>
                              </Tooltip>
                            </Permission>
                          </Stack>
                        </Stack>
                      </CardContent>
                    </Card>
                  ))}
                </Stack>
                <Card sx={{ mt: 2, borderRadius: 2 }}>
                  <TablePagination
                    component="div"
                    count={_ProductSupplier.total}
                    rowsPerPage={page}
                    page={currentPage}
                    onPageChange={(e, newPage) => setCurrentPage(newPage)}
                    rowsPerPageOptions={[15, 25, 50, 100]}
                    onRowsPerPageChange={(event) => {
                      setPage(parseInt(event.target.value, 10));
                    }}
                  />
                </Card>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Card sx={{ borderRadius: 2 }}>
                  {loading ? <LinearProgress /> : null}
                  <Typography m={2} variant="h5" color="primary" align="center">
                    لا توجد بيانات
                  </Typography>
                </Card>
              </Grid>
            )
          ) : (
            <Grid item xs={12}>
              <Box sx={{ height: "70vh", width: "100%" }}>
                <DataGrid
                  rows={_ProductSupplier.data}
                  columns={columns}
                  pageSize={page}
                  page={currentPage}
                  rowCount={_ProductSupplier.total}
                  loading={loading}
                  rowHeight={50}
                  pagination
                  paginationMode="server"
                  selectionModel={[]}
                  onPageChange={(newPage) => setCurrentPage(newPage)}
                  rowsPerPageOptions={[15, 25, 50, 100]}
                  onPageSizeChange={(newPageSize) => {
                    setPage(newPageSize);
                  }}
                  components={{
                    LoadingOverlay: LinearProgress,
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ProductSupplierTable;
